export function getDataLoaderResponseData(response) {
  return response.data
}

export function getDataLoaderServerError(error) {
  return error?.response ?? error
}

export function isDataLoaderLatestLoad({ latestLoadId, loadId }) {
  return loadId === latestLoadId
}
